import * as navigation from './navigation';
import * as routing from '~/routing/redux/actions';
import * as version from './version';

export default { navigation, routing, version };
